import { initialUIDashboardState } from './constants';

export type DashboardUIState = typeof initialUIDashboardState;

export enum CalendarManagementViewEnum {
  actionSelect = 'actionSelect',
  editRates = 'editRates',
  confirmBlockoff = 'confirmBlockoff',
  confirmBooking = 'confirmBooking',
  createBlockoff = 'createBlockoff',
  createBooking = 'createBooking',
  cancelBooking = 'cancelBooking',
  dateSelect = 'dateSelect',
  editBooking = 'editBooking',
  reviewBlockoff = 'reviewBlockoff',
  reviewRate = 'reviewRate',
  reviewNewBooking = 'reviewBooking',
  reviewEditBooking = 'reviewEditBooking',
  editBookingWarning = 'editBookingWarning',
  transferBookingWarning = 'transferBookingWarning',
  transferBooking = 'transferBooking',
}

export enum CalendarManagementActionsEnum {
  blockoff = 'blockoff',
  rates = 'rates',
  createBooking = 'createBooking',
  editBooking = 'editBooking',
  cancelBooking = 'cancelBooking',
  transferBooking = 'transferBooking',
}
